export interface GeometryInterface {
    type: string;
    coordinates: Array<[number, number]>;
}

export interface GeometryPointInterface {
    type: string;
    coordinates: [number, number];
}

export const defaultGeometryRecord = {
    type: "",
    coordinates: []
};
